// Sister Tac - Show Data
// Modifica facilmente date, orari e informazioni qui

// ============================================
// VENUES - Informazioni specifiche per ogni teatro
// ============================================
export const VENUES = {
  "teatro-sant-anna": {
    id: "teatro-sant-anna",
    name: "Teatro Sant'Anna",
    address: "Via Brione 40",
    city: "Torino",
    zone: "zona Parella/San Donato",
    capacity: 197,
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2817.6!2d7.68!3d45.07!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDXCsDA0JzE2LjIiTiA3wrA0MCc0OC4wIkU!5e0!3m2!1sit!2sit!4v1600000000000!5m2!1sit!2sit",
    mapsLink: "https://maps.google.com/?q=Teatro+Sant'Anna+Via+Brione+40+Torino",
    parking: {
      description: "Parcheggio gratuito disponibile nelle vie limitrofe. Zona a traffico regolare.",
      details: [
        "Parcheggio libero in Via Brione e strade adiacenti",
        "Strisce blu a pagamento su Corso Svizzera (tariffa serale ridotta)",
        "Nessun parcheggio privato del teatro"
      ]
    },
    publicTransport: {
      description: "Via Brione 40 a Torino (zona Parella/San Donato) è raggiungibile principalmente con la linea tram 13, che percorre via Pietro Celesia nelle immediate vicinanze. Altre opzioni includono le linee bus 65 e 71 su Corso Svizzera, oltre alla metro fermata \"Bernini\" (a circa 10-15 min a piedi).",
      lines: [
        { type: "Tram 13", stop: "Fermata \"Celesia\" (via Pietro Celesia angolo via Brione)" },
        { type: "Bus 65, 71, VE1", stop: "Fermate su Corso Svizzera" },
        { type: "Metropolitana", stop: "Fermata \"Bernini\" o \"Racconigi\" (linea M1)" }
      ]
    },
    accessibility: "Il teatro è accessibile ai disabili. Contattaci per esigenze specifiche.",
    hasBar: true,
    barInfo: "Bar interno con bevande e snack disponibili prima dello spettacolo e durante l'intervallo.",
    openingTime: "La biglietteria apre 45 minuti prima dello spettacolo.",
    contact: {
      phone: "3477135882",
      phoneDisplay: "+39 347 713 5882"
    },
    faq: [
      {
        question: "Dove si trova esattamente il Teatro Sant'Anna?",
        answer: "Il Teatro Sant'Anna si trova in Via Brione 40, Torino, nella zona Parella/San Donato. È facilmente raggiungibile con mezzi pubblici o in auto."
      },
      {
        question: "C'è un parcheggio vicino al teatro?",
        answer: "Sì, è possibile parcheggiare gratuitamente nelle vie limitrofe come Via Brione e strade adiacenti. Su Corso Svizzera ci sono strisce blu a pagamento con tariffa serale ridotta."
      },
      {
        question: "Il teatro ha un bar?",
        answer: "Sì, il Teatro Sant'Anna dispone di un bar interno dove è possibile acquistare bevande e snack prima dello spettacolo e durante l'intervallo."
      },
      {
        question: "A che ora apre il teatro?",
        answer: "La biglietteria e l'ingresso aprono 45 minuti prima dell'inizio dello spettacolo."
      },
      {
        question: "Il teatro è accessibile ai disabili?",
        answer: "Sì, il Teatro Sant'Anna è accessibile alle persone con disabilità. Per esigenze specifiche, ti consigliamo di contattarci in anticipo."
      }
    ]
  },
  "teatro-incontro": {
    id: "teatro-incontro",
    name: "Teatro Incontro",
    address: "Via Caprilli 31",
    city: "Pinerolo",
    zone: "centro città",
    capacity: 200,
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2823.5!2d7.33!3d44.88!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDTCsDUyJzQ4LjAiTiA3wroxOSc0OC4wIkU!5e0!3m2!1sit!2sit!4v1600000000000!5m2!1sit!2sit",
    mapsLink: "https://maps.google.com/?q=Teatro+Incontro+Via+Caprilli+31+Pinerolo",
    parking: {
      description: "Parcheggio disponibile nelle vicinanze del teatro.",
      details: [
        "Parcheggio gratuito in Piazza Fontana (a 2 minuti a piedi)",
        "Parcheggio a pagamento in centro città",
        "Strisce bianche gratuite nelle vie limitrofe"
      ]
    },
    publicTransport: {
      description: "Pinerolo è raggiungibile da Torino con treno (linea SFM3, circa 40 minuti da Torino Porta Nuova). Il teatro si trova a circa 10 minuti a piedi dalla stazione ferroviaria.",
      lines: [
        { type: "Treno SFM3", stop: "Stazione di Pinerolo (10 min a piedi dal teatro)" },
        { type: "Bus extraurbano", stop: "Linee da Torino e comuni limitrofi" },
        { type: "Auto", stop: "Da Torino: tangenziale sud, uscita Pinerolo (circa 40 km)" }
      ]
    },
    accessibility: "Il teatro è accessibile ai disabili. Contattaci per esigenze specifiche.",
    hasBar: true,
    barInfo: "Servizio bar disponibile.",
    openingTime: "Le porte aprono 30 minuti prima dello spettacolo.",
    contact: {
      phone: "3480430201",
      phoneDisplay: "+39 348 043 0201"
    },
    faq: [
      {
        question: "Dove si trova il Teatro Incontro?",
        answer: "Il Teatro Incontro si trova in Via Caprilli 31, nel centro di Pinerolo. È facilmente raggiungibile in treno da Torino o in auto."
      },
      {
        question: "Come arrivo a Pinerolo da Torino?",
        answer: "In treno: linea SFM3 da Torino Porta Nuova (circa 40 minuti). In auto: tangenziale sud di Torino, uscita Pinerolo (circa 40 km, 45 minuti)."
      },
      {
        question: "C'è parcheggio vicino al teatro?",
        answer: "Sì, è disponibile parcheggio gratuito in Piazza Fontana a 2 minuti a piedi dal teatro, oltre a posti nelle vie limitrofe."
      },
      {
        question: "A che ora aprono le porte?",
        answer: "Le porte del teatro aprono 30 minuti prima dell'inizio dello spettacolo."
      }
    ]
  },
  "teatro-torretta": {
    id: "teatro-torretta",
    name: "Teatro Torretta",
    address: "Piazza N.S. di Lourdes 3",
    city: "Asti",
    zone: "centro città",
    capacity: 192,
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2830.5!2d8.20!3d44.90!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDTCsDU0JzAwLjAiTiA4wrAxMicwMC4wIkU!5e0!3m2!1sit!2sit!4v1600000000000!5m2!1sit!2sit",
    mapsLink: "https://maps.google.com/?q=Teatro+Torretta+Piazza+NS+di+Lourdes+3+Asti",
    parking: {
      description: "Parcheggio disponibile nelle vicinanze del teatro.",
      details: [
        "Parcheggio in Piazza N.S. di Lourdes",
        "Parcheggi a pagamento nel centro città",
        "Strisce bianche gratuite nelle vie limitrofe"
      ]
    },
    publicTransport: {
      description: "Asti è raggiungibile in treno da Torino (circa 30-40 minuti). Il teatro si trova in centro città, facilmente raggiungibile a piedi dalla stazione.",
      lines: [
        { type: "Treno", stop: "Stazione di Asti (15 min a piedi dal teatro)" },
        { type: "Auto", stop: "Da Torino: autostrada A21, uscita Asti Est (circa 55 km)" }
      ]
    },
    accessibility: "Il teatro è accessibile ai disabili. Contattaci per esigenze specifiche.",
    hasBar: true,
    barInfo: "Servizio bar disponibile.",
    openingTime: "Le porte aprono 30 minuti prima dello spettacolo.",
    contact: {
      phone: "3477135882",
      phoneDisplay: "+39 347 713 5882"
    },
    faq: [
      {
        question: "Dove si trova il Teatro Torretta?",
        answer: "Il Teatro Torretta si trova in Piazza N.S. di Lourdes 3, nel centro di Asti. È facilmente raggiungibile in treno da Torino o in auto."
      },
      {
        question: "Come arrivo ad Asti da Torino?",
        answer: "In treno: da Torino Porta Nuova (circa 30-40 minuti). In auto: autostrada A21, uscita Asti Est (circa 55 km, 50 minuti)."
      },
      {
        question: "C'è parcheggio vicino al teatro?",
        answer: "Sì, è disponibile parcheggio in Piazza N.S. di Lourdes e nelle vie limitrofe."
      },
      {
        question: "A che ora aprono le porte?",
        answer: "Le porte del teatro aprono 30 minuti prima dell'inizio dello spettacolo."
      }
    ]
  }
};

// Venue di default
export const DEFAULT_VENUE_ID = "teatro-sant-anna";

export const SHOW_INFO = {
  title: "SISTER TAC",
  subtitle: "Una drag queen in abito da suora",
  organization: "Emozioni in Corso",
  venue: VENUES[DEFAULT_VENUE_ID],
  ticketPrice: 13,
  duration: "~2 ore",
  interval: "10 minuti",
  hasBar: true
};

export const SHOW_DATES = [
  { date: "14 Marzo 2026", day: "Sabato", time: "21:00", available: true, venueId: "teatro-sant-anna" },
  { 
    date: "28 Marzo 2026", 
    day: "Sabato", 
    time: "21:15", 
    available: true,
    venueId: "teatro-incontro",
    phone: "3480430201",
    prices: {
      intero: 15,
      ridotto: 12,
      ridottoLabel: "Ridotto (sotto 12 anni)"
    },
    note: "Durante la serata sarà possibile acquistare le 'Colombe della Pace' - Emergency"
  },
  { date: "8 Maggio 2026", day: "Venerdì", time: "21:00", available: true, venueId: "teatro-sant-anna" },
  { date: "9 Maggio 2026", day: "Sabato", time: "21:00", available: true, venueId: "teatro-sant-anna" },
  { date: "23 Maggio 2026", day: "Sabato", time: "21:00", available: true, venueId: "teatro-sant-anna" },
  { date: "24 Maggio 2026", day: "Domenica", time: "21:00", available: true, venueId: "teatro-sant-anna" },
  { 
    date: "12 Settembre 2026", 
    day: "Sabato", 
    time: "21:00", 
    available: true,
    venueId: "teatro-torretta",
    phone: "3477135882",
    prices: {
      intero: 15,
      ridotto: 12,
      ridottoLabel: "Ridotto (sotto 12 anni)"
    }
  }
];

// Helper per ottenere venue di una data
export const getVenueForDate = (show) => {
  if (show.venueId && VENUES[show.venueId]) {
    return VENUES[show.venueId];
  }
  if (show.venue) {
    // Retrocompatibilità con vecchia struttura
    return show.venue;
  }
  return VENUES[DEFAULT_VENUE_ID];
};

export const CONTACT_INFO = {
  whatsapp: "393477135882",
  whatsappDisplay: "+39 347 713 5882",
  whatsappLink: "https://wa.me/393477135882",
  email: "emozioniincorsoaps@gmail.com",
  paypal: "stefanobordieri@gmail.com",
  satispayLink: "https://web.satispay.com/download/qrcode/S6Y-SVN--D6C52146-A533-4254-9485-72511EEDA87D",
  iban: "IT58V0326801012052718503260"
};

export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/sistertac/",
  facebook: "https://www.facebook.com/profile.php?id=61587869662399"
};

export const PAYMENT_METHODS = [
  {
    name: "Satispay",
    description: "Il più veloce! Ricevi link immediato",
    icon: "💜",
    recommended: true
  },
  {
    name: "PayPal",
    description: `Invia a ${CONTACT_INFO.paypal}`,
    icon: "💙"
  },
  {
    name: "Bonifico",
    description: `IBAN: ${CONTACT_INFO.iban}`,
    icon: "🏦"
  }
];

export const FAQ_DATA = [
  {
    question: "Quanto costa il biglietto?",
    answer: "Il biglietto costa 13€ a persona."
  },
  {
    question: "Come posso pagare?",
    answer: "Accettiamo Satispay (il più veloce!), PayPal e bonifico bancario. Dopo la prenotazione via WhatsApp ti invieremo il link per il pagamento."
  },
  {
    question: "Posso regalare un biglietto?",
    answer: "Certo! Offriamo biglietti regalo personalizzati con il nome del destinatario. Basta indicarlo nella prenotazione e prepareremo un biglietto speciale."
  },
  {
    question: "Come vengono assegnati i posti?",
    answer: "I posti vengono assegnati in ordine di prenotazione. Prima prenoti, migliore sarà la tua posizione! La conferma del posto avviene solo dopo il pagamento."
  },
  {
    question: "Quanto dura lo spettacolo?",
    answer: "Lo spettacolo dura circa 2 ore, con un intervallo di 10 minuti. Tempo perfetto per un drink al bar interno!"
  },
  {
    question: "C'è un bar nel teatro?",
    answer: "Sì! Il Teatro Sant'Anna ha un bar interno dove potrai goderti un aperitivo prima dello spettacolo o durante l'intervallo. 🍷"
  },
  {
    question: "Il teatro è accessibile?",
    answer: "Il teatro è accessibile alle persone con mobilità ridotta. Contattaci su WhatsApp per organizzare al meglio la tua visita."
  },
  {
    question: "Posso cambiare nominativo o chiedere rimborso?",
    answer: "Il cambio nominativo è possibile fino a 48 ore prima dello spettacolo. Per i rimborsi, contattaci almeno 7 giorni prima della data. Valuteremo ogni richiesta caso per caso."
  },
  {
    question: "Dove posso parcheggiare?",
    answer: "Ci sono parcheggi gratuiti nelle vie limitrofe al teatro. In Via Brione e nelle strade adiacenti troverai facilmente posto."
  },
  {
    question: "A che ora devo arrivare?",
    answer: "Ti consigliamo di arrivare almeno 20 minuti prima dell'inizio per trovare posto e goderti un drink al bar. Lo spettacolo inizia puntuale!"
  }
];

export const REVIEWS = [
  {
    name: "Maria G.",
    text: "Ho riso dall'inizio alla fine! Sister Tac è uno spettacolo che ti entra nel cuore. Da vedere assolutamente!",
    rating: 5
  },
  {
    name: "Luca P.",
    text: "Incredibile energia sul palco. I costumi, le coreografie, la musica... tutto perfetto. Porterò tutti i miei amici!",
    rating: 5
  },
  {
    name: "Francesca R.",
    text: "Non mi aspettavo di commuovermi così tanto. Dietro le risate c'è un messaggio bellissimo. Grazie!",
    rating: 5
  },
  {
    name: "Alessandro M.",
    text: "Il cast è fenomenale. Due ore volate in un attimo. Prenotate subito, ne vale ogni centesimo!",
    rating: 5
  }
];

export const GALLERY_IMAGES = [
  {
    url: "https://customer-assets.emergentagent.com/job_sister-tac/artifacts/wkwqlzk4_630809036_10239067888746123_4211688117565513517_n.jpg",
    alt: "Sister Tac - Drag queen con suore sul palco",
    className: "large"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_sister-tac/artifacts/gz11huaf_sara%204.jpg",
    alt: "Sister Tac - Drag queen sul palco con abito blu",
    className: "tall"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_sister-tac/artifacts/ro5r3boj_image_20fbbba8.jpg",
    alt: "Sister Tac - Performance con luci viola e paillettes",
    className: ""
  },
  {
    url: "https://customer-assets.emergentagent.com/job_sister-tac/artifacts/ephlou1f_PHOTO-2026-01-18-21-58-47.jpg",
    alt: "Le suore del San Bartolomeo in scena",
    className: "wide"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_sister-tac/artifacts/ltmg9uxs_PHOTO-2026-01-18-20-59-31.jpg",
    alt: "Il cast completo di Sister Tac con il pubblico",
    className: ""
  },
  {
    url: "https://customer-assets.emergentagent.com/job_07b8a370-0254-4e5d-80a4-612f798333f5/artifacts/9rthsrk3_Finale%20sister%20Tac.jpeg",
    alt: "Finale Sister Tac - Cast completo con braccia alzate",
    className: "large"
  }
];

export const VIDEO_PROMO = "https://customer-assets.emergentagent.com/job_sister-tac/artifacts/ba1ir0zs_Sister%20Tac%20%20video%20promo%20-%20SD%20480p.mov";

// Helper function to generate WhatsApp message
export const generateWhatsAppUrl = (data) => {
  const { nome, cognome, telefono, numBiglietti, data: dataSpettacolo, note } = data;
  const message = `Ciao Stefano! Vorrei prenotare per SISTER TAC. Nome: ${nome} ${cognome}. Telefono: ${telefono}. Biglietti: ${numBiglietti}. Data: ${dataSpettacolo || 'Da definire'}.${note ? ' Note: ' + note : ''}`;
  return `https://wa.me/${CONTACT_INFO.whatsapp}?text=${encodeURIComponent(message)}`;
};

export const generateGiftWhatsAppUrl = (data) => {
  const { nomeDestinatario, cognomeDestinatario, daChi, numBiglietti, note } = data;
  const message = `Ciao Stefano! Vorrei un BIGLIETTO REGALO per SISTER TAC. Per: ${nomeDestinatario} ${cognomeDestinatario}. Da: ${daChi}. Biglietti: ${numBiglietti}.${note ? ' Note: ' + note : ''}`;
  return `https://wa.me/${CONTACT_INFO.whatsapp}?text=${encodeURIComponent(message)}`;
};
